export default __webpack_public_path__ + "static/media/icon.thermal underwear.b13be5a2.svg";